import ApplicationController from './application_controller'

// The purpose of this controller is to properly initialize an hCaptcha div by executing it's remote js code provided by hcaptcha similar to this:
// <script src="https://hcaptcha.com/1/api.js" async="" defer=""></script>

export default class extends ApplicationController {

	static values = {
		initialize: { type: Boolean, default: false },
	}

	connect() {
		if (this.initializeValue) {
			window.hcaptcha.render(this.element);
		}
	}
}
